module.exports = __webpack_public_path__ + "static/media/Q5-8.44d29d7d.jpg";